import Checkbox from '@storeblocks/checkbox-atom';
import { type FC, useState } from 'react';
import styled from 'styled-components';

import { useAddFundsModalContext } from '../AddFundsModalContext';

interface Props {
  isin: string;
}

export const CheckboxCell: FC<Props> = ({ isin }) => {
  const { selectedIsins } = useAddFundsModalContext();

  const [value, setValue] = useState(selectedIsins.has(isin));

  const handleChanged = (checked: boolean): void => {
    setValue(checked);

    if (selectedIsins.has(isin)) {
      selectedIsins.delete(isin);
    } else {
      selectedIsins.add(isin);
    }
  };

  return (
    // The checkbox does not properly align horizontally
    // since it has display inline-flex. Therefore, we wrap it
    // in a div that has display flex to make it align properly.
    <Flex data-test={`select-fund-option-${isin}`}>
      <Checkbox
        aria-label="Select fund"
        value="selected"
        checked={value}
        onChange={(event) => handleChanged(event.target.checked)}
      />
    </Flex>
  );
};

const Flex = styled.div`
  display: flex;
`;
